import { render, staticRenderFns } from "./noData.vue?vue&type=template&id=19146b74"
import script from "./noData.vue?vue&type=script&lang=ts"
export * from "./noData.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports